export interface AuthHeaders {
  token: string;
  refreshToken: string;
}
